export const MARKETING_VERSION_V1 = 'v1';
export const MARKETING_VERSION_V2 = 'v2';
export const MARKETING_VERSION_V3 = 'v3';
export const MARKETING_VERSION_DEFAULT = MARKETING_VERSION_V1;

export function resolveMarketingVersion(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (
    normalized === MARKETING_VERSION_V1 ||
    normalized === MARKETING_VERSION_V2 ||
    normalized === MARKETING_VERSION_V3
  ) {
    return normalized;
  }

  return MARKETING_VERSION_DEFAULT;
}

const RAW_MARKETING_VERSION =
  typeof __CEDRUM_MARKETING_VERSION__ === 'string'
    ? __CEDRUM_MARKETING_VERSION__
    : import.meta?.env?.VITE_MARKETING_VERSION;

export const MARKETING_VERSION = resolveMarketingVersion(RAW_MARKETING_VERSION);
export const IS_MARKETING_V2 = MARKETING_VERSION === MARKETING_VERSION_V2;
export const IS_MARKETING_V3 = MARKETING_VERSION === MARKETING_VERSION_V3;
